/**
 * @packageDocumentation
 * @module      SystemState.ts
 * @description Provides convenient ways of accessing the system state.
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
export default class SystemState {
    /**
     * Return the state string in a friendlier form.
     *
     * @param stateString One of the values from the system_states table in the database, or the empty string.
     */
    static getFriendlyName(stateString) {
        switch (stateString) {
            case 'AVAILABLE':
                return "Available";
            case 'ASSOCIATED':
                return "Associated";
            case 'ASSOCIATION_PENDING':
                return "Association Pending";
            case 'ASSOCIATION_REJECTED':
                return "Association Rejected";
            case 'ASSOCIATION_REQUEST_TIMED_OUT':
                return "Assoc Request Timed Out";
            case 'ASSOCIATION_REQUEST_CANCELED':
                return "Assoc Request Canceled";
            case 'MISSING':
                return "Missing";
            case 'UNAVAILABLE':
                return "Unavailable";
            case 'DISABLED':
                return "Disabled";
            case '':
                return "";
            default:
                return "Unknown State";
        }
    }
    /**
     * Return a color suitable for displaying an icon (just a dot) next to the state.
     *
     * @param stateString One of the values from the system_states table in the database, or the empty string.
     *
     * @returns A Shui color such as "rgb(var(--functional-yellow))" or "var(--support-5)".
     *          (This module accounts for the inconsistency in Shui: some colors require being wrapped in
     *          rgb(var(...)) while others come with rgba already and must be only var(...).)
     */
    static getIconColor(stateString) {
        switch (stateString) {
            case 'AVAILABLE':
                return "rgb(var(--functional-green))";
            case 'ASSOCIATED':
                return "var(--support-5)";
            case 'ASSOCIATION_PENDING':
                return "rgb(var(--functional-yellow))";
            case 'ASSOCIATION_REJECTED':
            case 'ASSOCIATION_REQUEST_TIMED_OUT':
            case 'ASSOCIATION_REQUEST_CANCELED':
                return "rgb(var(--functional-red))";
            case 'MISSING':
            case 'UNAVAILABLE':
            case 'DISABLED':
            default:
                return "rgb(var(--ui-6))";
        }
    }
}
//# sourceMappingURL=SystemState.js.map